import { render } from "./LogoBw.vue?vue&type=template&id=34222f60&scoped=true"
const script = {}

import "./LogoBw.vue?vue&type=style&index=0&id=34222f60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34222f60"

export default script